import { render, staticRenderFns } from "./OperatorDetails.vue?vue&type=template&id=6b136d1f&"
import script from "./OperatorDetails.vue?vue&type=script&lang=js&"
export * from "./OperatorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports